import Vue from 'vue'

import ApiService from '@/core/services/api.service'
import JwtService from '@/core/services/jwt.service'

import { eventBus } from '@/main'

// action types
export const VERIFY_AUTH = 'verifyAuth'
export const LOGIN = 'login'
export const LOGOUT = 'logout'
export const AUTH_TOKEN = 'authToken'

// mutation types
export const PURGE_AUTH = 'logOut'
export const SET_AUTH = 'setUser'
export const CONFIRM_AUTH = 'confirmUser'
export const SET_PASSWORD = 'setPassword'
export const SET_ERROR = 'setError'
export const SET_RESPONSE_STATE = 'setResponseState'

const TOAST_GLOBAL = 'showToast'

const state = {
  errors: null,
  user: {
    username: '',
    access_token: '',
    ttl: '',
  },
  isAuthenticated: !!JwtService.getToken(),

  responses: {
    auth: false,
    authToken: false,
  },
}

const getters = {
  currentUser(state) {
    return state.user
  },
  isAuthenticated(state) {
    return state.isAuthenticated
  },
}

const actions = {
  [LOGIN](context, credentials) {
    return new Promise((resolve) => {
      context.commit(SET_RESPONSE_STATE, { type: 'auth', status: true })
      ApiService.post(process.env.VUE_APP_AUTH, credentials)
        .then(({ data }) => {
          context.commit(SET_RESPONSE_STATE, { type: 'auth', status: false })
          context.commit(SET_AUTH, data)
          eventBus.$emit('clearNotificationsInterval')
          eventBus.$emit('restartNotificationsTimer')
          eventBus.$emit('checkNotificationsCount')
          resolve(data)
        })
        .catch(err => {
          const error = err.response.data
          eventBus.$emit(TOAST_GLOBAL, {
            message: error.message,
            variant: 'danger'
          })
          context.commit(SET_ERROR, err.response.data)
        })
        .finally(() => {
          context.commit(SET_RESPONSE_STATE, { type: 'auth', status: false })
        })
    })
  },
  [LOGOUT](context) {
    context.commit(PURGE_AUTH)
  },
  [VERIFY_AUTH](context) {
    if (JwtService.getToken()) {
      ApiService.setHeader()
      ApiService.get(process.env.VUE_APP_AUTH)
        .then(({ data }) => {
          context.commit(CONFIRM_AUTH, data)
          eventBus.$emit('refreshAuth')
        })
        .catch(({ err }) => {
          context.commit(PURGE_AUTH)
          context.commit(SET_ERROR, err.response.data)
        })
    } else {
      context.commit(PURGE_AUTH)
    }
  },
  [AUTH_TOKEN](context, token) {
    return new Promise((resolve) => {
      context.commit(SET_RESPONSE_STATE, { type: 'authToken', status: true })
      ApiService.get(`${process.env.VUE_APP_TOKEN_AUTH}?token=${token}`)
        .then(({ data }) => {
          context.commit(SET_RESPONSE_STATE, { type: 'authToken', status: false })
          context.commit(SET_AUTH, data)
          eventBus.$emit('clearNotificationsInterval')
          eventBus.$emit('restartNotificationsTimer')
          eventBus.$emit('checkNotificationsCount')
          resolve(data)
        })
        .catch(({ err }) => {
          context.commit(SET_RESPONSE_STATE, { type: 'authToken', status: false })
          context.commit(SET_ERROR, err.response.data)
        })
    })
  },
}

const mutations = {
  [SET_ERROR](state, error) {
    state.errors = error
  },
  [SET_AUTH](state, user) {
    state.isAuthenticated = true
    Object.keys(user).forEach((key) => {
      Vue.set(state.user, key, user[key])
    })
    state.errors = {}
    JwtService.saveToken(state.user.access_token)
  },
  [CONFIRM_AUTH](state, user) {
    state.isAuthenticated = true
    Object.keys(user).forEach((key) => {
      Vue.set(state.user, key, user[key])
    })
    state.errors = {}
    JwtService.saveToken(user.access_token)
  },
  [SET_PASSWORD](state, password) {
    state.user.password = password
  },
  [PURGE_AUTH](state) {
    state.isAuthenticated = false
    state.user = {}
    state.errors = {}
    JwtService.destroyToken()
  },
  [SET_RESPONSE_STATE](state, { type, status }) {
    state.responses[type] = status
  },
}

export default {
  state,
  actions,
  mutations,
  getters,
}
